// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5538":"7168b071","8924":"8061208e"}[chunkId] + ".chunk.css";
};